module.exports = __webpack_public_path__ + "static/img/SUB_01_00.535e87f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/SUB_01_00.png
// module id = /Xir
// module chunks = 1